<template>
	<div class="auto-complete-org">
		<div class="auto-complete-org__input-area" :class="{'with-results':has_results}">
			<input v-model="query" placeholder="Find company" />
			<svg-magnify-glass class="search-icon"></svg-magnify-glass>
		</div>
		<ul class="auto-complete-org__results-area" v-if="has_results">
			<li v-for="(result,r) in filtered_results" :key="`org_${r}`" @click="selectOrg(result)">
				<div class="logo-img">
					<img :src="result.logo" :alt="result['org-name']"/>
				</div>
				<div class="label" v-html="result['org-name']"></div>
			</li>
		</ul>
	</div>
</template>

<script>
	import algoliasearch from 'algoliasearch';

	export default {
		props: {
			comparing_ids: {
				type: Array
			},
			column: {
				type: Number
			}
		},
		data() {
      return {
				query: '',
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'orgs-2021-dev' : 'orgs-2021-LIVE',
				searchObject: {
					hitsPerPage: 6,
					facets: [],
					facetFilters: [],
					numericFilters: []
				},
				results: [],
        performDebouncedSearch: null
      }
    },
		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);
      // Throttle our Algolia requests as the person types.
      this.performDebouncedSearch = _.debounce(this.performSearch, 250, false);
		},
		methods: {
			performSearch() {
				this.index
					.search(this.query, this.searchObject)
					.then((results) => {
						//console.log("we got initial hits:",results.hits,results.nbHits);
						console.log("organisations auto complete raw results:", results);
						if (results.nbHits > 0) {
							this.results = results.hits;
						} else {
							this.results = [];
						}
					});
			},
			selectOrg(org) {
				this.$emit('select',this.column,org);
			}
		},
		computed: {
			filtered_results() {
				return this.results.filter((result) => {
					return this.comparing_ids.includes(result['org-main-id']) == false;
				})
			},
			has_results() {
				return this.filtered_results.length > 0;
			}
		},
		watch: {
			'query': {
				handler() {
					this.performDebouncedSearch();
				}
			}
		}
	}
</script>
